import React from "react";
import style from "./Promociones.module.css";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import { useMediaQuery } from "@material-ui/core";
export const Campaign = () => {
  const mobile = useMediaQuery("(max-width:768px)");
  return (
    <div className={!mobile ? style.container : style.containerMob}>
      <div className={!mobile ? style.textContainer : style.textContainerMob}>
        <h5 className={!mobile ? style.text : style.textMob}>
          Somos una marca matriz con diferentes giros de negocio. Nuestra pasión
          es la transformación para cubrir las necesidades de nuestros clientes
          y aliados. Somos evolución, siempre conservando nuestros valores y
          principios, pero moldeándonos a tus necesidades.
        </h5>

        <ArrowDownwardRoundedIcon
          className={style.icon}
        ></ArrowDownwardRoundedIcon>
      </div>
    </div>
  );
};
